import React from "react";
import { useTranslation } from "react-i18next";
import HeadCont from "../../components/common/HeadCont";
import { useSelector } from "react-redux";
import InfoContainer from "../../components/mypage/InfoContainer";
import useInfo from "../../hooks/useInfo";

const Bookmark = () => {
  const { t } = useTranslation('mypage');
  const { loginInfo, navTab } = useSelector((state) => state.commonApp);

  const infoParams = useInfo("myPage", loginInfo, t('bookmarks.title'));

  return (
    <>
      <HeadCont />
      <div className="mt-14" />
      <h1 className="mx-4 mb-2.5 mt-2 text-subtitle1">{t('bookmarks.title')}</h1>

      {/* Post Container from MyPage (Different from Post Container from Community) */}

      <InfoContainer infoParams={infoParams} loginInfo={loginInfo} />
    </>
  );
};

export default Bookmark;
